module.exports = __webpack_public_path__ + "e1d3d50349e5382a20702a1ebc518760.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/truck-s.png
// module id = 2140
// module chunks = 0